module.exports = __webpack_public_path__ + "img/w3_location_dark.ea536f26.png";